import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshPromise = null;

api.interceptors.request.use((config) => {
  const rawOperator = sessionStorage.getItem('activeOperator');
  if (rawOperator) {
    try {
      const operator = JSON.parse(rawOperator);
      if (operator?.id) config.headers['x-operator-id'] = operator.id;
      if (operator?.name) config.headers['x-operator-name'] = operator.name;
    } catch (err) {
      sessionStorage.removeItem('activeOperator');
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;
    const url = originalRequest?.url || '';
    const isAuthEndpoint = url.includes('/auth/login') || url.includes('/auth/refresh');

    if (status === 401 && originalRequest && !originalRequest._retry && !isAuthEndpoint) {
      originalRequest._retry = true;

      try {
        if (!refreshPromise) {
          refreshPromise = axios.post(
            `${BACKEND_URL}/api/auth/refresh`,
            {},
            { withCredentials: true }
          ).finally(() => {
            refreshPromise = null;
          });
        }

        await refreshPromise;
        return api(originalRequest);
      } catch (refreshError) {
        if (window.location.pathname !== '/login') {
          window.location.replace('/login');
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
